export const RESULT_STATUSES = ['likely', 'maybe', 'manual_review', 'not_found', 'error', 'rejected'];

export const STRATEGIES = ['json_status', 'http_status', 'body_match', 'manual_link'];

export const SITE_CATALOG = [
  {
    id: 'github',
    name: 'GitHub',
    category: 'coding',
    strategy: 'json_status',
    checkUrl: 'https://api.github.com/users/{account}',
    profileUrl: 'https://github.com/{account}',
    successStatus: 'likely',
    confidence: 90,
    missingStatuses: [404],
    expect: { type: 'field_equals', path: ['login'] },
    knownGood: ['torvalds', 'gaearon'],
    knownMissing: ['wiedersehen-user-missing-github-0001'],
  },
  {
    id: 'gitlab',
    name: 'GitLab',
    category: 'coding',
    strategy: 'json_status',
    checkUrl: 'https://gitlab.com/api/v4/users?username={account}',
    profileUrl: 'https://gitlab.com/{account}',
    successStatus: 'maybe',
    confidence: 70,
    missingStatuses: [404],
    expect: { type: 'array_field_equals', path: ['username'] },
    missing: { type: 'empty_array' },
    knownGood: ['gitlab-bot'],
    knownMissing: ['wiedersehen-user-missing-gitlab-0001'],
  },
  {
    id: 'reddit',
    name: 'Reddit',
    category: 'social',
    strategy: 'json_status',
    checkUrl: 'https://www.reddit.com/user/{account}/about.json',
    profileUrl: 'https://www.reddit.com/user/{account}',
    successStatus: 'maybe',
    confidence: 65,
    missingStatuses: [404],
    expect: { type: 'field_equals', path: ['data', 'name'] },
    knownGood: ['spez'],
    knownMissing: ['wiedersehen-user-missing-reddit-0001'],
  },
  {
    id: 'keybase',
    name: 'Keybase',
    category: 'identity',
    strategy: 'manual_link',
    profileUrl: 'https://keybase.io/{account}',
    confidence: 35,
    manualReason: 'api_signal_not_reliable_enough',
    knownGood: ['max'],
    knownMissing: ['wiedersehen-user-missing-keybase-0001'],
  },
  ...manualSites([
    ['instagram', 'Instagram', 'social', 'https://www.instagram.com/{account}/'],
    ['x', 'Twitter/X', 'social', 'https://x.com/{account}'],
    ['tiktok', 'TikTok', 'video', 'https://www.tiktok.com/@{account}'],
    ['pinterest', 'Pinterest', 'images', 'https://www.pinterest.com/{account}/'],
    ['medium', 'Medium', 'blog', 'https://medium.com/@{account}'],
    ['flickr', 'Flickr', 'images', 'https://www.flickr.com/people/{account}/'],
    ['vimeo', 'Vimeo', 'video', 'https://vimeo.com/{account}'],
    ['soundcloud', 'SoundCloud', 'music', 'https://soundcloud.com/{account}'],
    ['spotify', 'Spotify', 'music', 'https://open.spotify.com/user/{account}'],
    ['deviantart', 'DeviantArt', 'art', 'https://www.deviantart.com/{account}'],
    ['twitch', 'Twitch', 'gaming', 'https://www.twitch.tv/{account}'],
    ['steam', 'Steam', 'gaming', 'https://steamcommunity.com/id/{account}'],
    ['aboutme', 'About.me', 'social', 'https://about.me/{account}'],
    ['gravatar', 'Gravatar', 'identity', 'https://en.gravatar.com/{account}'],
    ['linkedin', 'LinkedIn', 'business', 'https://www.linkedin.com/in/{account}/'],
    ['xing', 'XING', 'business', 'https://www.xing.com/profile/{account}'],
    ['facebook', 'Facebook', 'social', 'https://www.facebook.com/{account}'],
    ['youtube', 'YouTube', 'video', 'https://www.youtube.com/@{account}'],
  ]),
];

function manualSites(entries) {
  return entries.map(([id, name, category, profileUrl]) => ({
    id,
    name,
    category,
    strategy: 'manual_link',
    profileUrl,
    confidence: 30,
    manualReason: 'manual_review_required',
    knownGood: ['example'],
    knownMissing: [`wiedersehen-user-missing-${id}-0001`],
  }));
}
